import React from "react";
import PaymentResultPage from "./PaymentResultPage";

export default function PaymentCancelPage() {
  return (
    <PaymentResultPage
      kind="cancel"
      title="Le paiement n'a pas été finalisé."
      message="Aucun débit n'a été confirmé. Vous pouvez reprendre plus tard ou retourner sur votre devis pour relancer le paiement si besoin."
      hint="Si vous avez quitté Stripe par erreur, votre devis reste disponible dans votre espace client."
    />
  );
}
